export function formatCurrency(currency) {
    const formatter = new Intl.NumberFormat("ru-RU", {
        style: "decimal",
        maximumFractionDigits: 0
    });

    return formatter.format(currency);
}